module.exports = __webpack_public_path__ + "assets/media/swallow_water_mix.f99bbd8e.mp4";